export default __webpack_public_path__ + "static/media/BCIseguros.24db7d32.svg";